import { EventEmitter } from '@angular/core'

import { IQuestionAnswer } from './'
import { Question } from '../../../data/models'

export class QuestionViewService {
  private _questionAnswered: EventEmitter<IQuestionAnswer[]> = new EventEmitter()

  public get questionAnswered(): EventEmitter<IQuestionAnswer[]> {
    return this._questionAnswered
  }

  public reviewMode: boolean
  public question: Question
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-view.service.ts